import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Button,
    InputGroup,
    InputGroupText,
} from "reactstrap";

/**
 * Discount Type Edit Form Component
 */
const DiscountTypeEditForm = ({
    store_domain,
    discount_type,
    max_discount,
    type,
    onInputChange,
    onSubmit,
}) => {
    return (
        <Form onSubmit={onSubmit}>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-store_domain-Input"
                    className="col-sm-1 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Store Domain
                </Label>
                <Col sm={3}>
                    <Input
                        value={store_domain}
                        type="text"
                        name="store_domain"
                        className="form-control"
                        id="horizontal-store_domain-Input"
                        onChange={onInputChange}
                        readOnly
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-placement-Input"
                    className="col-sm-1 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Type
                </Label>
                <Col sm={3}>
                    <Input
                        type="select"
                        name="discount_type"
                        className="form-control"
                        id="horizontal-placement-Input"
                        onChange={onInputChange}
                        value={discount_type}
                        required
                    >
                        <option value="Automatic">Automatic</option>
                        <option value="Manual">Manual</option>
                        <option value="Paused">Paused</option>
                    </Input>
                </Col>
                {discount_type === 'Manual' && (
                    <Col sm={1}>
                        <InputGroup>
                            <Input
                                value={max_discount}
                                type="input"
                                name="max_discount"
                                className="form-control"
                                id="horizontal-discount-Input"
                                onChange={onInputChange}
                                required
                            />
                            <InputGroupText>%</InputGroupText>
                        </InputGroup>
                    </Col>
                )}
            </FormGroup>
            <FormGroup className="row justify-content-end">
                <Col sm={11}>
                    <div>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-md"
                        >
                            Update
                        </Button>
                    </div>
                </Col>
            </FormGroup>
        </Form>
    );
};

DiscountTypeEditForm.propTypes = {
    store_domain: PropTypes.string.isRequired,
    discount_type: PropTypes.string.isRequired,
    max_discount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.string.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default DiscountTypeEditForm;

